import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Accordion, Spinner } from "react-bootstrap";
import CollapseCard, { initialValueForTrack } from "./CollapseCard";
import { createMedia } from "../../../../../api/media";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { showAlbum } from "../../../../../api/albums";
import store from "../../../../../redux/store";
import actions from "../../../../../redux/actions";

function AlbumTracksEdit(props) {
  const history = useHistory();
  const { new_tracks, current_user } = useSelector(
    ({ new_tracks, current_user }) => ({
      new_tracks,
      current_user,
    })
  );

  useEffect(() => {
    showAlbum(props.match.params.album_id).then(({ data: { album } }) => {
      setMedia(
        new_tracks.map((new_track) => ({
          s3_object_key: new_track.s3_object_key,
          ...initialValueForTrack(new_track, album),
        }))
      );
      setAlbum(album);
      setActiveCardKey(new_tracks.length ? new_tracks[0].s3_object_key : 0);
      setFetchingAlbum(false);
    });
  }, []);

  const { album_id } = useParams();
  const [fetchingAlbum, setFetchingAlbum] = useState(true);
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [album, setAlbum] = useState(null);
  const [activeCardKey, setActiveCardKey] = useState(0);

  const onUpdateFormData = (s3_object_key) => (values) =>
    setMedia(
      media.map((medium) =>
        medium.s3_object_key == s3_object_key
          ? { s3_object_key, ...values }
          : medium
      )
    );

  const invalidMedia = media.some(
    (medium) => !medium.title || !medium.s3_object_key
  );

  const onSubmit = async () => {
    try {
      setLoading(true);
      await createMedia({
        media: media.map((medium) => ({
          type: "SoundTrack",
          is_track_type: "album_track",
          s3_object_key: medium.s3_object_key,
          title: medium.title,
          preview_image_id: medium.preview_image && medium.preview_image.id,
          album_medium_attributes: {
            album_id,
          },
          post_on_create: medium.post_on_create,
          tags: medium.tags,
          description: medium.description,
          label: medium.label,
          download_link: medium.download_link,
          featured_artists: medium.featured_artists,
          lyrics: medium.lyrics,
          is_mastered: medium.is_mastered,
          release_date: medium.release_date,
        })),
      });
      store.dispatch(actions.resetNewUploadedTracks());
      history.push(`/upload/done`);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tracks-upload m-5">
      <h1>Edit Track Details </h1>
      {fetchingAlbum ? (
        <div className="py-5 my-5 text-center">
          <Spinner
            animation="border"
            variant="primary"
            size="lg"
            role="status"
            // style={{ minWidth: "1rem", minHeight: "1rem" }}
          />
        </div>
      ) : (
        <Accordion onSelect={setActiveCardKey} defaultActiveKey={activeCardKey}>
          {new_tracks.map((new_track, index) => (
            <CollapseCard
              album={album}
              new_track={new_track}
              activeCardKey={activeCardKey}
              onUpdateFormData={onUpdateFormData(new_track.s3_object_key)}
            />
          ))}
        </Accordion>
      )}

      <div className="py-5">
        <div className="d-flex flex-column align-items-center">
          <button
            onClick={onSubmit}
            className="btn btn-primary btn-md py-2"
            disabled={invalidMedia || fetchingAlbum || loading}
          >
            {loading && (
              <Spinner animation={"border"} size={"sm"} className="mr-3" />
            )}
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default AlbumTracksEdit;
